import { Grid2 } from "@mui/material";
import PropertyCard from "../../components/properties/PropertyCard";
import { Link } from "react-router-dom";

function MyProperty({ property, lastPropertyRef }) {
  return (
    <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} ref={lastPropertyRef}>
      <Link
        to={`/my-properties/${property.id}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <PropertyCard property={property} />
      </Link>
    </Grid2>
  );
}

export default MyProperty;
